import isEmpty from 'lodash/isEmpty';

export const parseJSON = jsonString => {
    if (!isEmpty(jsonString)) {
        try {
            return JSON.parse(jsonString);
        } catch (e) {
        }
    }
    return null;
}

export const stringifyJSON = (value, replacer, space) => {
    try {
        return JSON.stringify(value, replacer, space);
    } catch (e) {
    }
    return null;
}
